import {lazyRegister} from '@/Core/lazyRegister';
import './input-floating.component.css';
import template from './input-floating.component.html';
import {createRandomId} from "@core/global";

class InputFloatingController {
    static $inject = ["$timeout"];
    placeholder: string;
    required: boolean = false;
    autocomplete: string | undefined;
    model: string | number | null;
    maxlength?: number;
    max?: number;
    min?: number;
    id?: string;
    type: 'text' | 'email' | 'url' | 'number' | 'password' | 'otp' = 'text';
    disabled: boolean = false;
    icon?: string;
    error?: string;
    containerClass?: string;
    inputClass?: string;
    showClearIcon: boolean = false;
    onChange: (params: { $value: string | number }) => void;
    onKeyup: (params: { $event: any }) => void;
    onEnter: (params: { $event: any }) => void;

    constructor(private readonly $timeout: ng.ITimeoutService) {
    }

    $onInit(): void {
        if (!this.id) {
            this.id = 'input-' + createRandomId();
        }
    }

    handleValueChange(): void {
        if (this.type === 'otp') {
            this.model = (this.model as string)?.replace(/[^0-9]/g, '');
        }

        if (this.onChange) {
            this.onChange({$value: this.model});
        }
    }

    handleKeydown($event: KeyboardEvent): void {
        if (this.type === 'number' &&
            !$event.ctrlKey && !$event.metaKey && $event.key.length === 1 && !/[\d.,-]/.test($event.key)) {
            $event.preventDefault();
        }
    }

    handlePaste(e: ClipboardEvent): void {
        if (this.type === 'number') {
            if (!/^[\d.,-]+$/.test(e?.clipboardData.getData('text') ?? '')) {
                e.preventDefault();
            }
        }
    }

    handleKeyup($event): void {
        if (this.type === 'otp') {
            const cleanValue = $event.target.value.replace(/[^0-9]/g, '');
            this.model = cleanValue;
            $event.target.value = cleanValue;
        }

        if (this.onKeyup) {
            this.onKeyup({$event: $event});
        }

        if (this.onEnter && $event.key === 'Enter') {
            this.onEnter({$event: $event});
        }
    }

    handleClearText(): void {
        if (this.disabled) {
            return;
        }

        this.model = '';

        if (this.onEnter) {
            this.$timeout(() => this.onEnter({$event: this.model}));
        }
    }
}

export const InputFloatingComponent: ng.IComponentOptions = {
    transclude: true,
    bindings: {
        placeholder: '@',
        id: '@?',
        value: '<?',
        model: '=?',
        name: '@?',
        type: '@?',
        disabled: '<?',
        readonly: '<?',
        required: '<?',
        autocomplete: '@?',
        minlength: '@?',
        maxlength: '@?',
        pattern: '@?',
        max: '<?',
        min: '<?',
        step: '<?',
        onChange: '&?',
        onKeyup: '&?',
        onEnter: '&?',
        icon: '@?',
        error: '<?',
        containerClass: '@?',
        inputClass: '@?',
        showClearIcon: '<?',
        hideRequiredIndicator: '<?'
    },
    template: template,
    controller: InputFloatingController
};

lazyRegister.component('inputFloating', InputFloatingComponent);
